import axiosInstance from "./axiosInstance";


export const fetchDistributors = async (data) => {
  const res = await axiosInstance.post(`/Dash/get_master`,data);
  const raw = res.data?.data[0]?.get_dash_master_data?.master_data
  return raw || []
};


export const addDistributor = async (data) => {
  const res = await axiosInstance.post(`/master/add_distributor`,data);
  const raw = res.data?.data[0]?.insert_update_distributor_master;
  return raw || []
};

